import { QConfigStatus } from '@exam-management/graphql';
import { LabelColor } from '@shared/components';

export const QCONFIG_STATUS_COLOR = {
  [QConfigStatus.Draft]: LabelColor.INFO,
  [QConfigStatus.Published]: LabelColor.SUCCESS,
  [QConfigStatus.Disabled]: LabelColor.GREY,
};

export const QCONFIG_STATUS_TEXT = {
  [QConfigStatus.Draft]: 'Draft',
  [QConfigStatus.Published]: 'Published',
  [QConfigStatus.Disabled]: 'Disabled',
};
